var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 784.37 1277.39",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M392.07 0l-8.57 29.11v844.63l8.57 8.55 392.06-231.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 0L0 650.54l392.07 231.75V472.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M392.07 956.52l-4.83 5.89v300.87l4.83 14.1 392.3-552.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 1277.38V956.52L0 724.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M392.07 882.29l392.06-231.75-392.06-178.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M0 650.54l392.07 231.75V472.33z"
  }))));
}

export default SvgEthereum;